(ns arthur.ui.index
  "`/`: the projects you own and edit, and a way to make one. A project is only
  ever at its own address, so this is where you are when you are in none.

  Over the editor rather than instead of it: the stage, the audio element and
  the draw loop stay mounted, and opening a project is showing them again."
  (:require [arthur.events.collab :as collab]
            [arthur.events.project :as project]
            [arthur.ui.settings :as settings]
            [arthur.ui.share :as share]
            [re-frame.core :as rf]))

(defn view []
  (when (= :index @(rf/subscribe [::collab/route]))
    (let [{:keys [username error]} @(rf/subscribe [::collab/me])
          {:keys [items loading?]} @(rf/subscribe [::project/listing])]
      [:div.index
       [:header.top
        [:span.brand "arthur"]
        [:span.status]
        [share/account]]
       [:main.index-body
        (if-not username
          [:<>
           [:h1 "arthur"]
           [:p.dim "Sign in, or create an account, to see your projects and make new ones."]]
          [:<>
           [:div.index-head
            [:h1 "projects"]
            [settings/new-project "new project"]]
           (when error [:p.warn error])
           (cond
             loading?       [:p.dim "…"]
             (empty? items) [:p.dim "Nothing yet. A new project starts empty."]
             :else
             [:ul.index-list
              (doall
               (for [{:keys [id name owner seq updated]} items
                     :let [path (collab/project-path id name)]]
                 ^{:key id}
                 [:li
                  [:a {:href path :on-click (fn [e] (.preventDefault e) (collab/navigate! path))}
                   (or name "untitled")]
                  [:span.dim (str (when (not= owner username) (str owner " · "))
                                  "r" seq " · " (subs (str updated) 0 10))]]))])])]])))
